const MS_PER_HOUR = 60 * 60 * 1000;
const MS_PER_DAY = 24 * MS_PER_HOUR;
const MS_PER_WEEK = 7 * MS_PER_DAY;

export const QUEUE_TTL_MS = 60 * MS_PER_DAY;
export const RAPID_PHASE_MS = MS_PER_HOUR;
export const HOURLY_PHASE_MS = MS_PER_DAY;
export const DAILY_PHASE_MS = 14 * MS_PER_DAY;
export const FAILED_THRESHOLD_MS = MS_PER_DAY;

const RAPID_RETRY_BASE_MS = 2000;

export const getQueuedElapsedMs = (queuedAt, now = Date.now()) => {
  const queuedTime = new Date(queuedAt).getTime();

  if (Number.isNaN(queuedTime)) {
    return null;
  }

  return now - queuedTime;
};

export const hasExceededFailedThreshold = (queuedAt, now = Date.now()) => {
  const elapsed = getQueuedElapsedMs(queuedAt, now);

  if (elapsed === null) {
    return false;
  }

  return elapsed >= FAILED_THRESHOLD_MS;
};

export const getExpiresAt = (queuedAt) => {
  const queuedTime = new Date(queuedAt).getTime();

  if (Number.isNaN(queuedTime)) {
    return null;
  }

  return new Date(queuedTime + QUEUE_TTL_MS).toISOString();
};

export const isQueueItemExpired = (item, now = Date.now()) => {
  if (!item) {
    return false;
  }

  const expiresAt = item.expiresAt ?? getExpiresAt(item.queuedAt);

  if (!expiresAt) {
    return true;
  }

  return new Date(expiresAt).getTime() <= now;
};

export const getNextRetryDelayMs = (retryCount, queuedAt, now = Date.now()) => {
  if (retryCount <= 0) {
    return 0;
  }

  const elapsed = getQueuedElapsedMs(queuedAt, now);

  if (elapsed === null) {
    return 0;
  }

  if (elapsed < RAPID_PHASE_MS) {
    const exponentialDelay = RAPID_RETRY_BASE_MS * 2 ** (retryCount - 1);
    const remainingInRapidPhase = RAPID_PHASE_MS - elapsed;

    return Math.min(exponentialDelay, remainingInRapidPhase);
  }

  if (elapsed < HOURLY_PHASE_MS) {
    return MS_PER_HOUR;
  }

  if (elapsed < DAILY_PHASE_MS) {
    return MS_PER_DAY;
  }

  return MS_PER_WEEK;
};
